import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const LINES = [
  {
    id: "wedding",
    label: "Undangan Wedding",
    pre: "ihtifaal.com/wedding/",
    post: "",
    words: ["andi-sarah", "bima-rania"],
    accent: "#8E4A54",
  },
  {
    id: "masjid",
    label: "Portal Masjid",
    pre: "",
    post: ".ihtifaal.com",
    words: ["masjid-alfalah", "al-ikhlas"],
    accent: "#0B6E4F",
  },
  {
    id: "gift",
    label: "Web Kejutan",
    pre: "gift.ihtifaal.com/",
    post: "",
    words: ["budi-ke-ani", "10th-anniversary"],
    accent: "#C24E22",
  },
];

function useTypewriter(words) {
  const [text, setText] = useState("");
  const state = useRef({ w: 0, i: 0, del: false });

  useEffect(() => {
    let timer;
    const tick = () => {
      const st = state.current;
      const word = words[st.w];
      if (!st.del) {
        st.i += 1;
        setText(word.slice(0, st.i));
        if (st.i >= word.length) {
          st.del = true;
          timer = setTimeout(tick, 1700);
          return;
        }
        timer = setTimeout(tick, 80);
      } else {
        st.i -= 1;
        setText(word.slice(0, st.i));
        if (st.i <= 0) {
          st.del = false;
          st.w = (st.w + 1) % words.length;
          timer = setTimeout(tick, 350);
          return;
        }
        timer = setTimeout(tick, 38);
      }
    };
    timer = setTimeout(tick, 500);
    return () => clearTimeout(timer);
  }, [words]);

  return text;
}

function TypingLine({ line }) {
  const text = useTypewriter(line.words);
  return (
    <div
      className="flex flex-col gap-3 rounded-2xl border border-[#141318]/10 bg-white/70 p-6 sm:flex-row sm:items-center sm:justify-between"
      data-testid={`url-line-${line.id}`}
    >
      <span
        className="flex items-center gap-2 text-sm font-semibold"
        style={{ color: line.accent }}
      >
        <span
          className="h-2 w-2 rounded-full"
          style={{ background: line.accent }}
        />
        {line.label}
      </span>
      <p className="font-mono text-sm text-[#1A1A1A] sm:text-base">
        <span className="text-[#4A4A4A]/70">{line.pre}</span>
        <span className="font-semibold" style={{ color: line.accent }}>
          {text}
        </span>
        <span
          className="type-caret"
          style={{ color: line.accent, background: line.accent }}
        />
        <span className="text-[#4A4A4A]/70">{line.post}</span>
      </p>
    </div>
  );
}

export default function LivingURL() {
  return (
    <section
      id="url-hidup"
      data-testid="living-url-section"
      className="bg-[#FDFBF7] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 max-w-2xl"
        >
          <p className="font-mono text-[11px] tracking-[0.4em] text-[#B76E79]">
            04 — URL YANG HIDUP
          </p>
          <h2 className="font-display mt-4 text-4xl text-[#1A1A1A] md:text-5xl">
            Alamat yang <em className="text-[#B76E79]">bercerita</em>
          </h2>
          <p className="mt-4 text-[#4A4A4A]">
            Setiap produk punya alamatnya sendiri — nama mempelai, nama masjid,
            nama usaha, nama pasangan. Bukan nomor, bukan kode acak.
          </p>
        </motion.div>
        <div className="flex flex-col gap-4">
          {LINES.map((line, i) => (
            <motion.div
              key={line.id}
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
            >
              <TypingLine line={line} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
